// <!-- GRACE:MODULE_START name="ui_auth" -->
// <!-- GRACE:DEPENDENCY target="ui_auth" -->
import { Navigate } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';

// <!-- GRACE:CONTRACT function="ProtectedRoute" -->
export default function ProtectedRoute({ children }: { children: React.ReactNode }) {
  const { isAuthenticated, loading } = useAuth();

  if (loading) {
    return (
      <div className="flex min-h-screen items-center justify-center">
        <p className="text-sm text-gray-500">Загрузка...</p>
      </div>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  return <>{children}</>;
}

// <!-- GRACE:MODULE_END name="ui_auth" -->
